import { atom } from "recoil";
import { IContact } from "../types/Contact";

export const SelectedCampaignsForContactsModal = atom<string | null>({
  key: "SelectedCampaignsForContactsModal",
  default: null,
});

export const ContactsForCampaignModal = atom<IContact[] | []>({
  key: "ContactsForCampaignModal",
  default: [],
});

export const ContactsForCampaignSort = atom<{ name?: number; email?: number }>({
  key: "ContactsForCampaignSort",
  default: {
    name: 1,
    email: undefined,
  },
});

interface ICampaignContactsAmount {
  totalFullAmount: number;
  activeFullAmount: number;
  totalAmount: number;
  activeAmount: number;
}

export const TotalActiveContactsAmountAtom = atom<ICampaignContactsAmount>({
  key: "TotalActiveContactsAmountAtom",
  default: {
    totalFullAmount: 0,
    activeFullAmount: 0,
    totalAmount: 0,
    activeAmount: 0,
  },
});

export const RefreshCampaignContacts = atom<boolean>({
  key: "RefreshCampaignContacts",
  default: false,
});
